import { useMutation } from '@tanstack/react-query'

import { createSession } from '../api'
import useSessionLocalStorage from './useSessionLocalStorage'

const useCreateSession = () => {
  const [, setSession] = useSessionLocalStorage()
  return useMutation({
    mutationKey: ['createSession'],
    mutationFn: async (app_id: string) => {
      setSession(undefined)
      const data = await createSession(app_id)
      return {
        ...data,
        attributes: {
          ...data.attributes,
          app_id,
        },
      }
    },
    onSuccess: data => setSession(data),
  })
}

export default useCreateSession
